export default "__VITE_ASSET__44fb4a73__"